import { TransactionHistoryRequestModel } from "api/baseTransactionHistory/TransactionHistoryRequestModel";

export class CashFlowRequestModel extends TransactionHistoryRequestModel {
  code?: string;
  limit?: number;
  page?: number;
  pagination?: boolean;
  name?: string;
  type?: number;
  created?: Record<string, unknown>[];
  fromDate?: string;
  toDate?: string;
  store?: string;
  staff?: string;
  isOnlyStore?: string;
  order?: string;

  constructor(data?: {
    code?: string;
    limit?: number;
    page?: number;
    pagination?: boolean;
    name?: string;
    type?: number;
    created?: Record<string, unknown>[];
    fromDate?: string;
    toDate?: string;
    store?: string;
    staff?: string;
    order?: string;
    isOnlyStore?: string;
  }) {
    super();
    this.code = data?.code;
    this.page = data?.page;
    this.limit = data?.limit;
    this.pagination = data?.pagination;
    this.name = data?.name;
    this.type = data?.type;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.created = data?.created;
    this.store = data?.store;
    this.staff = data?.staff;
    this.order = data?.order;
    this.isOnlyStore = data?.isOnlyStore;
  }
}
